export const IGNORED_BY_WOVN_CLASS_NAME = 'wovn-ignore'
